export interface DamagePutAwayStateType {
  isLoading: boolean
}

export const initialState: DamagePutAwayStateType = {
  isLoading: false,
}

// Preserve the legacy empty reducer, which returns undefined after dispatch.
// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function damagePutAway(): void {}
